import React from "react";
import { database, storage } from "../../Firebase/firebase";

function AdminAbout({ profile, handleChange }) {
  const {
    id,
    first_name,
    last_name,
    bio,
    about,
    tagline,
    resumeImage,
    resumeImagePath,
    resumePath,
  } = profile;
  const handleUpdate = (e) => {
    e.preventDefault();
    for (let key in profile) {
      if (!profile[key]) {
        alert("cant be empty");
        return;
      }
    }
    database.collection("profile").doc(profile.id).update(profile);
  };
  const imageRef = React.useRef();
  const fileRef = React.useRef();
  const [uploadState, setUploadState] = React.useState(false);
  const handleUpdateResume = () => {
    if (imageRef.current?.files[0]?.name && fileRef.current?.files[0]?.name) {
      if (
        imageRef.current?.files[0]?.type.includes("image") &&
        fileRef.current?.files[0]?.type.includes("pdf")
      ) {
        setUploadState(true);
        if (resumeImagePath) {
          storage.ref(`profile/${resumeImagePath}`).delete();
        }
        if (resumePath) {
          storage.ref(`profile/${resumePath}`).delete();
        }
        const uploadTask = storage
          .ref(`profile/${imageRef.current.files[0].name}`)
          .put(imageRef.current.files[0]);

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            // setPostState(Math.floor((snapshot.bytesTransferred/snapshot.totalBytes)*100)+1)
          },
          (error) => {},
          () => {
            storage
              .ref("profile")
              .child(imageRef.current.files[0].name)
              .getDownloadURL()
              .then((resumeImage) => {
                const uploadTask2 = storage
                  .ref(`profile/${fileRef.current.files[0].name}`)
                  .put(fileRef.current.files[0]);

                uploadTask2.on(
                  "state_changed",
                  (snapshot) => {
                    // setPostState(Math.floor((snapshot.bytesTransferred/snapshot.totalBytes)*100)+1)
                  },
                  (error) => {},
                  () => {
                    storage
                      .ref("profile")
                      .child(fileRef.current.files[0].name)
                      .getDownloadURL()
                      .then((url) => {
                        database.collection("profile").doc(id).update({
                          resumeImage,
                          resumeImagePath: imageRef.current.files[0].name,
                          resume: url,
                          resumePath: fileRef.current.files[0].name,
                        });
                        setUploadState(false);
                      });
                  }
                );
              });
          }
        );
      }
    }
  };
  return (
    <div className="adminAboutContainer flexBox">
      <div className="UpdateProfile flexBox">
        <h1>Update profile</h1>
        <form className="UpdateProfileForm flexBox" onSubmit={handleUpdate}>
          <div className="name">
            <input
              type="text"
              name="first_name"
              placeholder="First Name"
              value={first_name}
              onChange={handleChange}
            />
            <input
              type="text"
              name="last_name"
              placeholder="Last Name"
              value={last_name}
              onChange={handleChange}
            />
          </div>
          <label>Bio </label>
          <textarea
            name="bio"
            placeholder="Bio"
            rows={2}
            value={bio}
            onChange={handleChange}
          />
          <label>Tag Line </label>
          <textarea
            name="tagline"
            placeholder="tagline"
            rows={2}
            value={tagline}
            onChange={handleChange}
          />
          <label>About </label>
          <textarea
            name="about"
            placeholder="about"
            rows={5}
            value={about}
            onChange={handleChange}
          />

          <button type="submit">Update</button>
        </form>
      </div>
      <div className="resumeUpload flexBox">
        <h1>Resume</h1>
        <img src={resumeImage} alt="Resume" />
        <div className="fileInputs">
          <div className="flexBox">
            <label>Resume Image </label>
            <input type="file" ref={imageRef}  />
          </div>
          <div className="flexBox">
            <label>Resume File</label>
            <input type="file" ref={fileRef}  />
          </div>
        </div>

        <button disabled={uploadState} onClick={handleUpdateResume}>
          Upload
        </button>
      </div>
    </div>
  );
}

export default AdminAbout;
